import Result from './react/Result';
import Empty from './react/Empty';
import Error from './react/Error';
import Success from './react/Success';
import Warning from './react/Warning';
export { Empty, Error, Success, Warning };
export default Result;